import { cn } from "../../utils/cn";

function PrimaryLabel({ title, className, classNameTitle, cadewaMode = false, children, isDisplayLine = false }) {
  return (
    <>
      <div className={cadewaMode ? cn("cadewa_primary_label", className) : cn("primary_label", className, /*{ "primary_label_line": isDisplayLine }*/)}>
        <div></div>
        {title && <span className={cn(classNameTitle)}>{title}</span>}
        {children}
      </div>
    </>
  );
}

export default PrimaryLabel;
